import React, {  useEffect, useState,useRef, useContext, Dispatch, SetStateAction } from "react";
import "./MenuPage.css"
import { TfiClose } from "react-icons/tfi";
import { emptyMenuPage, Menu, MenuContentPage, ReviewProps,typeDailyMenu} from "../../../components/types/types";
import backPage from '../../../image/Menu/backMenu.webp'
import MaskBackground from "../../../components/maskBackground/maskBackground";
import bottomLine from '../../../image/Menu/baseLine.webp'
import { AppContext } from "../../../context/AppContext";
import MenuRestau from "../../../components/Menu/menu";
import Loading from "../../../components/loading/loading";
import { useSearchParams } from "react-router-dom";

const BlockReview = React.lazy(() => import("../../../components/blockReview/BlockReview"));

interface MenuPageProps  {
    Menu: Menu,
    StyleMenu:number,
    isInteractMenu:boolean;
    idRestaurant:number,
    note:number,
    dateUpdate:Date,
    dailyMenu:typeDailyMenu,
    listReview:ReviewProps[],
    setListReview:Dispatch<SetStateAction<ReviewProps[]>>,
    reviewLoad:boolean,
    setReviewLoad:Dispatch<SetStateAction<boolean>>,
    nbrReviewLoad:number,
} 

const MenuPage:React.FC<MenuPageProps> = ({Menu,reviewLoad,nbrReviewLoad,setReviewLoad,listReview,setListReview,dailyMenu,dateUpdate,StyleMenu,isInteractMenu,idRestaurant,note}) => {
    const {setShowPlat,showPlat} = useContext(AppContext)
    
    const [showAlertInteract,setShowAlertInteract] = useState(false)
    const [showDailyMenu,setShowDailyMenu] = useState(false)
    const [photoRestaurateur,setPhotoRestaurateur] = useState('')
    const containerRef = useRef<HTMLDivElement | null>(null);
    const [alertClass, setAlertClass] = useState<'show' | 'hide' | ''>('');
    const [fullPlat,setFullPlat] = useState('')

    useEffect(() => {   
        if (typeof window === 'undefined') return;
        const BREAKPOINT = 1050;
        const canCrossBreakpoint = () => {
            const w = window.innerWidth;
            const h = window.innerHeight;
            const minSide = Math.min(w, h);
            const maxSide = Math.max(w, h);
            return minSide < BREAKPOINT && maxSide > BREAKPOINT;
        };

        const isLarge = () => window.innerWidth > BREAKPOINT;
        const initialIsLarge = isLarge();
        
        const handleChange = () => {
            if (!canCrossBreakpoint()) return;
            const nowIsLarge = isLarge();
            if (nowIsLarge !== initialIsLarge) {
            window.location.reload();
            }
        };
        window.addEventListener('orientationchange', handleChange);
        window.addEventListener('resize', handleChange);

        return () => {
            window.removeEventListener('orientationchange', handleChange);
            window.removeEventListener('resize', handleChange);
        };
    },[])

    const dobbleMenu = React.useMemo<[MenuContentPage, MenuContentPage][]>(() => {
        
        if (!Menu || !Menu.length || Menu.length === 0) {
            return [[emptyMenuPage, emptyMenuPage],[emptyMenuPage, emptyMenuPage]];
        } 
        let newGroups:[MenuContentPage,MenuContentPage][] = [[emptyMenuPage,Menu[0]]]
        const patch = Menu[0].imgback ? { imgback: Menu[0].imgback } : {};
        const patchFont = Menu[0].fontfamilytext ? { fontfamilytext: Menu[0].fontfamilytext } : {};
        const patchFontTitle = Menu[0].fontfamilytitle ? { fontfamilytitle: Menu[0].fontfamilytitle } : {};
        const front: MenuContentPage = { ...emptyMenuPage, ...patch, ...patchFont, ...patchFontTitle };
        const back:  MenuContentPage = { ...emptyMenuPage, ...patch, ...patchFont, ...patchFontTitle };
        for(let i = 1; i < Menu.length; i+=2) {
            let group:[MenuContentPage,MenuContentPage] = [front,back]
            group[0] = Menu[i]
            if(i + 1 < Menu.length) group[1] = Menu[i+1]
            newGroups.push(group)
        }
        if(newGroups[newGroups.length - 1][1].elements.length > 0) newGroups = [...newGroups,[front,back]]
        return newGroups
    }, [Menu]);


    const currentDailyMenu = React.useMemo(() => {
        if(dailyMenu.image && Array.isArray(dailyMenu.dates)) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            if (dailyMenu.dates.length > 1) {
                
                const startDate = new Date(dailyMenu.dates[0]);
                const endDate = new Date(dailyMenu.dates[1]);
                startDate.setHours(0, 0, 0, 0);
                endDate.setHours(0, 0, 0, 0);
                return !(today < startDate || today > endDate);
            } else if (dailyMenu.dates.length === 1) {
                const menuDate = new Date(dailyMenu.dates[0]);
                menuDate.setHours(0, 0, 0, 0);
                return today.getTime() === menuDate.getTime();
            } else return false;
        } else return false
    }, [dailyMenu]);
    const [searchParams] = useSearchParams();

    useEffect(() => {
         const intent = searchParams.get('intent');
        if(isInteractMenu && !intent) {
            setTimeout(() => {
            setAlertClass('show');
            setShowAlertInteract(true);

            setTimeout(() => {
                setAlertClass('hide');
                setTimeout(() => {
                setShowAlertInteract(false);
                setAlertClass('');
                }, 250);
            }, 6000); 
            }, 1000);
        }
    },[isInteractMenu])

    
    const fetchReview = async (idResto:number) => {
        try {
            if(reviewLoad) return
            const [avisRes, infoRes] = await Promise.all([
                fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/getAvis`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ idResto }),
                }),
                fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/getInfoResponse`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ idResto }),
                }),
            ]);

            const avisData = await avisRes.json();
            const infoData = await infoRes.json();

            setListReview(avisData.avis || [])
            setReviewLoad(true)
            if (infoData.success && infoData.info?.photo) {
                setPhotoRestaurateur(infoData.info.photo)
            } 
        } catch (e) {
            console.error(e);
        }
    }
    useEffect(() => {
        if(idRestaurant && idRestaurant !== -1) {
            const observer = new IntersectionObserver(
                (entries) => {
                    if (entries[0].isIntersecting) {
                        fetchReview(idRestaurant);
                        observer.disconnect();
                    }
                },
                { threshold: 0.1 } 
            );
            const observerPlat = new IntersectionObserver(
                (entries) => {
                    if (entries[0].isIntersecting) {
                        setShowPlat([-1,0,0])
                    }
                },
                { threshold: 0.3 } 
            );

            let timer = window.setTimeout(() => {
                if (containerRef.current) {
                observer.observe(containerRef.current);
                observerPlat.observe(containerRef.current);
                }
            }, 800);

            return () => {
                window.clearTimeout(timer);
                observer.disconnect();
                observerPlat.disconnect();
            }
        }
    }, [idRestaurant]);
    
    const updateAddResponse = React.useCallback((id:number,response:string) => {
        setListReview(prevList =>
            prevList.map(review =>
                review.idavis === id
                    ? { 
                        ...review, 
                        response, 
                        post_date_response: new Date() 
                    }
                    : review
            )
        );
    }, []);
    const updateDeleteReview = React.useCallback((id:number) => {
         setListReview(prevList => prevList.filter(elem => elem.idavis !== id));
    }, []);
    const updateDeleteResponse = React.useCallback((id:number) => {
        setListReview(prevList =>
            prevList.map(elem =>
                elem.idavis !== id ? elem : { ...elem, response: "" }
            )
        );
    }, []);
    const updateNewReview = React.useCallback((newReview:ReviewProps) => {
        setListReview(prevList => {
            const prevListFilter = prevList.filter(elem => elem.iduser !== newReview.iduser);
            return [newReview, ...prevListFilter];
        });
    }, []);
    const [isImageLoaded,setIsImageLoaded] = useState(false)
    useEffect(() => {
        if (showDailyMenu && !isImageLoaded) {
             const img = new Image();
            img.src = dailyMenu.image;
            if (img.complete) {
                setIsImageLoaded(true);
            } else {
                img.onload = () => {
                    setIsImageLoaded(true);
                };
            }
        }
    }, [showDailyMenu]);
    return (
        <>
        {
                showDailyMenu && <>
                    <div className="containerDailyMenuPage primaryBack" >
                        <TfiClose size={15} className="pointer lowOpacityHover close" onClick={() => setShowDailyMenu(false)}/>
                        <p style={{marginBottom:'0.3em'}} className="largeTitle">Menu du jour</p>
                        <img src={bottomLine} className="line" loading="lazy" alt="ligne "/>
                            {!isImageLoaded && <Loading />}
                            <div className="dailyPart">
                                
                                <img
                                    src={dailyMenu.image}
                                    className="dailyMenu"
                                    loading="lazy"
                                    alt="menu du jour"
                                    onLoad={() => {setIsImageLoaded(true)}}
                                    style={{
                                    display: isImageLoaded ? 'flex' : 'none'
                                    }}
                                />
                            </div>
                        

                        <div className="dates midText">
                            <i>Menu du :&nbsp;</i>
                            {dailyMenu.dates.length === 1 ? (                          
                                <i>
                                    {new Intl.DateTimeFormat("fr-FR", {
                                        weekday: "long",
                                        day: "numeric",
                                        month: "long"
                                    })
                                    .format(new Date(dailyMenu.dates[0]))
                                    .replace(/^./, (str) => str.toUpperCase())}
                                </i>
                            ) : (
                                <>
                                    <i>{new Date(dailyMenu.dates[0]).toLocaleDateString("fr-FR", { day: "numeric", month: "2-digit" })}</i>
                                    <i style={{ marginRight: '5px', marginLeft: '5px' }}>au</i>
                                    <i>{new Date(dailyMenu.dates[1]).toLocaleDateString("fr-FR", { day: "numeric", month: "2-digit" })}</i>
                                </>
                            )}
                        </div>

                    </div>
                    <MaskBackground zIndex={16} closeFunction={() => setShowDailyMenu(false)}/>
                </>
            }
        <div className={`menuCorpRestau primaryBack ${currentDailyMenu ? 'hasDailyMenu' : '' }`} id="menuCorpRestau"  >
            <MenuRestau dobbleMenu={dobbleMenu} styleMenu={StyleMenu} interactmenu={isInteractMenu} dateUpdate={dateUpdate} setFullPlat={setFullPlat}/>
            {currentDailyMenu && <div className={`buttonTodayMenu pointer smallTitle ${isInteractMenu ? 'isInteract' : '' }`} onClick={() => setShowDailyMenu(true)}><div className="container secondaryBack" ><div className="decorationLine" ></div><div className="shadow"></div><img src={backPage} loading="lazy" alt="fond"/><span style={{zIndex:2}}>Menu du jour</span><div className="decorationLine" ></div></div></div> }
        </div>
        {
            showAlertInteract && showPlat[0] === -1 &&  <div className={`alertIsInteract XsmallTextBold primaryBack ${alertClass}`} >
                <span>Cette carte est interactive, cliquer sur</span>
                <div className="secondLine"><span>un plat avec "&nbsp;</span><div className="interactPoint"></div><span>&nbsp;" pour voir sa photo.</span></div>
            </div>
        }
        {
            fullPlat !== '' ? 
            <div onClick={() => setFullPlat('')}>
                <MaskBackground zIndex={20} closeFunction={() => setFullPlat('')}/>
                <div className="containerFullImgPlat">
                    <TfiClose style={{top:'1em', right:'1em', padding:'0.3em'}} className="fullScreen pointer lowOpacityHover" size={20} />
                    <img className="fullIMG" src={fullPlat} loading="lazy" alt="plat large"/> 
                </div>
                
            </div>
            : undefined 
        }
        <div  ref={containerRef} className="reviewsSuspenseShell">
            <React.Suspense fallback={<div style={{minHeight:'350px'}}><Loading /></div>}>
                <BlockReview idResto={idRestaurant} ListAvis={listReview} note={note} updateNewReview={updateNewReview} updateDeleteResponse={updateDeleteResponse} updateAddResponse={updateAddResponse} updateDeleteReview={updateDeleteReview} imgRestaurateur={photoRestaurateur} nbrReviewLoad={nbrReviewLoad}/>
            </React.Suspense>
        </div>
        </>
    )
}

export default MenuPage